export const PlayIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='26'
    height='24'
    fill='none'
    viewBox='0 0 26 24'
  >
    <rect
      width='24.5'
      height='22.5'
      x='0.75'
      y='0.75'
      stroke='currentColor'
      strokeWidth='1.5'
      rx='11.25'
    />
    <path
      fill='currentColor'
      d='M17.41 11.728a.3.3 0 010 .544l-6.484 2.995a.3.3 0 01-.426-.272v-5.99a.3.3 0 01.426-.272l6.484 2.995z'
    />
  </svg>
)

